import React from 'react';
import { Collapse } from '@mui/material';

import {
  Paper,
  Typography,
  Switches,
  TextField,
  CardContent,
  CardHeader,
} from '@occc-app/design-system';

import copies from './copies';
import { TriggerOnFulfillmentProps } from './types';

const TriggerOnFulfillment: React.FC<TriggerOnFulfillmentProps> = ({ open }) => {
  const { title, description } = copies;

  return (
    <Paper>
      <CardHeader
        title={
          <Typography variant='h6' component='p' gutterBottom>
            {title}
          </Typography>
        }
        subheader={<Typography color='textSecondary'>{description}</Typography>}
        action={<Switches name='triggerPreferences.triggerOnFulfillment' data={{}} />}
      />
      <Collapse in={open} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <TextField name='marketingContent.triggeredMessageContent.fulfillmentSms' />
        </CardContent>
      </Collapse>
    </Paper>
  );
};

export default TriggerOnFulfillment;
